import React, { useEffect } from 'react';

//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/composable/icn_composable_04.png';
import icn_02 from '../../assets/img/landingPage/hyperautomation/icn_hyperautomation-02.png';
import icn_03 from '../../assets/img/landingPage/cloudP/icn_cloudP_03.png';
import icn_04 from '../../assets/img/landingPage/cloudP/icn_cloudP_04.png';
import icn_05 from '../../assets/img/landingPage/cloudP/icn_cloudP_05.png';
import icn_06 from '../../assets/img/landingPage/cloudP/icn_cloudP_06.png';
import icn_07 from '../../assets/img/landingPage/cloudP/icn_cloudP_07.png';
import icn_08 from '../../assets/img/landingPage/cloudP/icn_cloudP_08.png';


import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/cloud/Cloud-home.png';

import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';
import icn_mision from '../../assets/img/landingPage/about/aboutUs_mision.svg';


const CloudProviders = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'Virtual-first architecture',
            text: " Run and manage APIs in virtualized environments without disrupting production.",
            altDescription: " Run and manage APIs in virtualized environments without disrupting production.",
            image: product_gateway,
        },
        Key_Feature_02: {
            title: "AI-powered automation",
            text: "Smart recommendations for configuration, monitoring, and adaptive security.",
            altDescription: "Smart recommendations for configuration, monitoring, and adaptive security.",
            image: product_gateway,
        },
        Key_Feature_03: {
            title: 'Granular security and access control',
            text: "Apply policies by user, client, environment, or geographic region.",
            altDescription: 'Apply policies by user, client, environment, or geographic region.',
            image: product_gateway,
        },
        Key_Feature_04: {
            title: 'Advanced monitoring and analytics',
            text: 
            "Custom dashboards for real-time operational and business metrics.",
            altDescription: 'Custom dashboards for real-time operational and business metrics.',
            image: product_gateway,
        },
        Key_Feature_05: {
            title: '100% API-exposed functionality',
            text: 
            " Full control and deep integration via AVAP’s comprehensive API layer.",
            altDescription: ' Full control and deep integration via AVAP’s comprehensive API layer.',
            image: product_gateway,
        },
    }
    

    //Two Deployment Models
    const items = [
        {
          icon: icn_01,
          title: 'Virtual-first architecture',
          paragraphs: [
            'Run and manage APIs in virtualized environments without disrupting production.',
          ],
          bullets: [
            'White-label the solution under your own brand',
            'Automate provisioning, monitoring, and control from your UI.',
            'Offer a native API Management experience to your customers.',
            'Seamlessly connect to your CRM, billing, and service catalog.'
          ],
          paragraphs2: [
            'Best for: Self-service platforms and tech providers with their own customer-facing portals.',
          ],
          
        },
        {
          icon: icn_02,
          title: 'Reseller Model',
          paragraphs: [
            'Distribute AVAP API Management as a ready-to-use platform:',
          ],
          bullets: [
            'Control users, environments, consumption, and billing.',
            'Access to multitenant environments and centralized management.',
            'Full support and operations handled by AVAP experts.',
          ],
          paragraphs2: [
            'Best for: Infrastructure providers looking to add robust services without complex development.',
          ],
        },
      ];
      
    const breakpointColumnsObj = {
        default: 2, //Cambio de columnas verticales
        1100: 2,
        700: 1          
    };

    //Key UseCases Bento
    const items2 = [
        {
            icon: icn_03,
            title: 'SaaS Startups',
            paragraphs: [
              'Offer ready-to-use environments for publishing and scaling product APIs.'
            ]
          },
        {
            icon: icn_04,
            title: 'Public Institutions & Education',
            paragraphs: [
              'Deliver audit-ready, compliant API governance without extra complexity.'
            ]
          },
        {
          icon: icn_05,
          title: 'Agencies and Integrators',
          paragraphs: [
            'Manage APIs across multiple clients with unified visibility and control.',
          ]
        },
        {
            icon: icn_06,
            title: 'Fintech Startups',
            paragraphs: [
              'Launch and secure APIs in minutes, without building infrastructure.',
            ]
          },
          {
            icon: icn_07,
            title: 'Logistics & eCommerce',
            paragraphs: [
              'Enable versioning, visibility, and access segmentation for third-party integrations.'
            ]
          },
          {
            icon: icn_08,
            title: 'Digital transformation for Legacy Enterprises',
            paragraphs: [
              'Enable banks, retailers, and insurers to manage APIs securely from your platform.',
            ],
          },
        
         
      ];
      
    const breakpointColumnsObj2 = {
        default: 3, //Cambio de columnas verticales
        1100: 2,
        700: 1          
    };

     //Key UseCases Bento
    const items3 = [
        {
            icon: icn_01,
            title: 'Virtual-first architecture',
            paragraphs: [
              'Run and manage APIs in virtualized environments without disrupting production.'
            ]
          },
        {
            icon: icn_02,
            title: 'AI-powered automation',
            paragraphs: [
              'Smart recommendations for configuration, monitoring, and adaptive security.'
            ]
          },
        {
          icon: icn_03,
          title: 'Granular security and access control',
          paragraphs: [
            'Apply policies by user, client, environment, or geographic region.',
          ]
        },
        {
            icon: icn_04,
            title: 'Advanced monitoring and analytics',
            paragraphs: [
              'Custom dashboards for real-time operational and business metrics.',
            ]
          },
          {
            icon: icn_05,
            title: '100% API-exposed functionality',
            paragraphs: [
              'Full control and deep integration via AVAP’s comprehensive API layer.'
            ]
          },
         
      ];
      
    const breakpointColumnsObj3 = {
        default: 3, //Cambio de columnas verticales
        1100: 2,
        700: 1          
    };
      

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center py-5">

                    <h1 className="fl-title-big m-0">AVAP for Cloud Providers</h1>
                    <p className="fl-title m-0 gradient-text fl-txt-container-s">Monetize API Management. Deliver innovation at scale.</p>
                                {/*<p className="fl-text fl-txt-container" >
                                Empower every team to automate work faster and smarter with AVAP Framework’s virtual-first, low-code platform — 
                                built to orchestrate tasks, data, and systems for both humans and AI agents.
                                </p>*/}
                </section>

                {/* Subtítulo descripción */}
                <section className="text-center pb-5">
                   <img
                        src={dashboard}
                        className="img-fluid mt-2 mb-4"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />                   
                    <h2 className="fl-subtitle pt-8">Offer Advanced API Management from Your Own Infrastructure</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                    With AVAP Framework, cloud providers can integrate and offer enterprise-grade API management as part of their native services — with full control, branded experience, and no need to build from scratch.</p>
                    <p className="fl-text text-center fl-txt-container-s">
                   Whether you're a platform provider, reseller, or infrastructure company, AVAP gives you the tools to expand your portfolio, increase client value, and streamline operations — all through a scalable, cloud-native architecture.</p>
                    {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>
                   
                    
                    <br />
                    &nbsp;
                    <br />&nbsp;
                    
                    {/*<h2 style={{ marginTop: '40px' }} className="fl-title m-0 gradient-text fl-title m-4">Why AVAP for Cloud Providers?</h2>

                   
                        <ul className="fl-bullets fl-text text-center .fl-txt-container-s">
                        <li className="fl-bullets">Expand your service offering with high-value API Management</li>
                        <li className="fl-bullets">Increase average revenue per customer with integrated, add-on services</li>
                        <li className="fl-bullets">Provide full-featured API monitoring, control, and security</li>
                        <li className="fl-bullets">Deliver everything under your brand with flexible integration options</li>
                        <li className="fl-bullets">Maintain complete control of customer experience and business model</li> </ul>*/}
                        
                </section>

                <div className="fl-card-border container text-center  p-5">
                    <h2 style={{ marginTop: '40px' }} className="fl-title mt-0 py-5 gradient-text fl-title m-4">Why AVAP for Cloud Providers?</h2>
                     {/* Sección Bullets */}
                    <ul className="fl-bullets fl-text text-center .fl-txt-container-s pb-5">
                    <li className="fl-bullets">Expand your service offering with high-value API Management</li>
                    <li className="fl-bullets">Increase average revenue per customer with integrated, add-on services</li>
                    <li className="fl-bullets">Provide full-featured API monitoring, control, and security</li>
                    <li className="fl-bullets">Deliver everything under your brand with flexible integration options</li>
                    <li className="fl-bullets">Maintain complete control of customer experience and business model</li> </ul>
                </div>

                <br />
                &nbsp;
                <br />&nbsp; 
               
                {/*<section className="container py-5 fl-gradientContainer mb-5" >
                <p className="fl-title-center m-0">Two Deployment Models</p><br />
                <p className="fl-subtitle text-center m-0 gradient-text">One Scalable Platform.</p>
            
                &nbsp;
                <br />&nbsp;    
                 <div className="row">
                        <div className="col-md-6 d-flex">
                            <img
                                src={icn_vision}
                                alt="Icon representing vision."
                                className="aboutIcon"
                            
                            />
                            <h3 className="fl-subtitle">1. Direct Provider Model</h3>
                            <p className="fl-text">
                            Integrate AVAP API Management directly into your platform via service APIs:
                            </p>
                                
                                <ul className="fl-bullets fl-text fl-txt-container-s" style={{ marginLeft: "7px" }}>
                                <li className="fl-bullets">White-label the solution under your own brand</li>
                                <li className="fl-bullets">Automate provisioning, monitoring, and control from your UI</li>
                                <li className="fl-bullets">Offer a native API Management experience to your customers</li>
                                <li className="fl-bullets">Seamlessly connect to your CRM, billing, and service catalog</li>
                                </ul>
                                <br/>
                            <p className="fl-text">
                            <strong style={{ fontWeight: 600 }}>Best for:</strong> Self-service platforms and tech providers with their own customer-facing portals.
                            </p>
                        </div>
                        <div className="col-md-6 pl-5">
                            <img
                                src={icn_mision}
                                alt="Icon of arrows representing mission."
                                className="mb-3 aboutIcon"
                               
                            />
                            <h3 className="fl-subtitle">2. Reseller Model</h3>
                            <p className="fl-text">
                            Distribute AVAP API Management as a ready-to-use platform:
                            </p>
                        
                                <ul className="fl-bullets fl-text  .fl-txt-container-s" style={{ marginLeft: "7px" }}>
                                <li className="fl-bullets">Control users, environments, consumption, and billing</li>
                                <li className="fl-bullets">Access to multitenant environments and centralized management</li>
                                <li className="fl-bullets">Full support and operations handled by AVAP experts</li>
                                </ul>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                            <p className="fl-text">
                            <strong style={{ fontWeight: 600 }}>Best for:</strong> Infrastructure providers looking to add robust services without complex development.
                            </p>  
                        </div>
                          
                        <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                    </div>
                            </section>*/}

                {/*Sección Tipos de Deployments */}
                <div className="container fl-gradientContainer my-5 p-5">
                <div className="fl-title text-center mb-6">
                Two Deployment Models
                <p className="fl-subtitle text-center m-0 gradient-text">One Scalable Platform.</p>
                </div>
            
                    <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items.map((item, idx) => (
                        <div key={idx} className="fl-card">
                        <img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        {item.bullets && (
                            <ul className="fl-bullets fl-text fl-txt-container-s" style={{ marginLeft: '7px' }}>
                            {item.bullets.map((b, i) => (
                                <li key={i} className="fl-bullets">{b}</li>
                            ))}
                            </ul>
                        )}
                        {item.paragraphs2.map((p, i) => (
                            <p key={i} className="fl-text bold pt-4">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>

                {/* Sección Key Features */}
                 {/*<div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                           
                            <br />
                            &nbsp;
                            <br />&nbsp;
                            <p className="fl-title-center m-0">What Makes AVAP Different?</p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>*/}

                {/*What Makes AVAP Different?*/}
                <div className="container pt-8">
                    <div className="fl-title text-center mb-5">
                    What Makes AVAP Different?
                    </div>
                        <Masonry
                        breakpointCols={breakpointColumnsObj3}
                        className="masonry-grid"
                        columnClassName="masonry-column"
                        >
                        {items3.map((item, idx) => (
                        <div key={idx} className="fl-card-s text-center grayGradient">
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                        <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                        ))}
                        </Masonry>
                </div>

                                

                {/*Sección Use Cases - bento */}
                <div className="container my-5 pt-6">
                <div className="fl-title text-center mb-6">
                 Key Use Cases
                </div>
            
                    <Masonry
                    breakpointCols={breakpointColumnsObj2}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items2.map((item2, idx) => (
                        <div key={idx} className="grayBox fl-card text-center">
                        <img src={item2.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item2.title}</p>
                        {item2.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>

                {/* Sección Key Uses Cases - Placas */}   
                {/*<section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col  mb-5">
                            <div className="fl-title text-center mb-3">
                            Key Use Cases
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Digital transformation for legacy enterprises
                                </p>
                                <p className="fl-text">
                                Enable banks, retailers, and insurers to manage APIs securely from your platform.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Agencies and integrators
                                </p>
                                <p className="fl-text">
                                Manage APIs across multiple clients with unified visibility and control.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Fintech startups
                                </p>
                                <p className="fl-text">
                                Launch and secure APIs in minutes, without building infrastructure.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Logistics & eCommerce
                                </p>
                                <p className="fl-text">
                                Enable versioning, visibility, and access segmentation for third-party integrations.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                SaaS startups
                                </p>
                                <p className="fl-text">
                                Offer ready-to-use environments for publishing and scaling product APIs.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                               
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Public institutions & education
                                </p>
                                <p className="fl-text">
                                Deliver audit-ready, compliant API governance without extra complexity.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>*/} 

                {/* Sección built for secure */} 
                <section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>

                                <div className="text-center">
                                    <h3 className='fl-title'>Built for Seamless Integration</h3>
                                    {/* Sección Bullets */}
                                    <ul className="fl-text fl-txt-container-s" >
                                    <li className="fl-bullets">Compatible with Node.js, Java, Python, .NET, Go, and other API languages</li>
                                    <li className="fl-bullets">Integrates with OAuth2, OIDC, LDAP, and enterprise security protocols</li>
                                    <li className="fl-bullets">Works with Postman, Swagger/OpenAPI, GitHub, Jenkins, Bitbucket, and more</li>
                                    <li className="fl-bullets">Expandable with the AVAP ecosystem: AVAP CLI, Publisher, ID, Marketplace, and beyond</li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <br />
                <br />
                <section className="text-center pb-5"> 
                    <h2 className="fl-title text-center mb-3" >Launch API Management as a Service</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                    AVAP Framework empowers cloud providers to lead the next wave of digital integration. Whether embedded or resold, AVAP API Management helps you unlock new revenue streams, simplify operations, and deliver enterprise-grade API solutions to your clients — fast.
                    {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>
                    </p>
                </section>

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default CloudProviders;
